import * as React from 'react';
import { ChangeEvent, ReactNode, useState } from 'react';
import { ParsedMathJax } from '../../components/ParsedMathJax';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';
import { Layout } from '../../Layout';

const defaultInput = `Inline TeX: $E = mc^2$

Display-style TeX using configured inline delimiters:
$$\\int_{-\\infty}^{\\infty} e^{-x^2} dx = \\sqrt{\\pi}$$

Escaped delimiters: \\(a^2 + b^2 = c^2\\)

HTML input: <strong>bold text</strong> with $\\boldsymbol{\\alpha}$`;

export function AdminMathjaxTest(): ReactNode {
  const [input, setInput] = useState<string>(defaultInput);

  return (
    <Layout title={'MathJax Render Test'}>
      <div className={'px-3 flex flex-column gap-4'}>
        <Card title={'Input'}>
          <p className={'mt-0'}>
            Enter text, HTML, and TeX delimiters to verify the frontend MathJax configuration.
          </p>
          <InputTextarea
            id={'admin-mathjax-test-input'}
            className={'w-full font-mono'}
            value={input}
            rows={12}
            autoResize={true}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>): void => setInput(event.target.value)}
          />
        </Card>

        <Card title={'Rendered preview'}>
          <div className={'line-height-3 white-space-normal'}>
            <ParsedMathJax key={input} dynamic={true} content={input.replace(/\n/g, '<br />')} />
          </div>
        </Card>

        <Card title={'Raw input'}>
          <pre className={'m-0 white-space-pre-wrap overflow-auto'}>{input}</pre>
        </Card>
      </div>
    </Layout>
  );
}

export default AdminMathjaxTest;